var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-window-manager" },
    [
      _vm.viewMode === _vm.VIEW_MODE_TYPES.GRID
        ? _c("GridChatWindowManager", {
            ref: "gridWindow",
            attrs: {
              contactList: _vm.contactList,
              toggleConversation: _vm.toggle,
              isLive: _vm.isLive,
              contact: _vm.cloneActiveContact,
              defaultSelectedFavoriteFilter: _vm.defaultSelectedFavoriteFilter,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showContactSwitch
        ? _c("ContactSwitchScreen", {
            attrs: { toggleConversation: _vm.toggle },
            on: {
              close: function () {
                return (_vm.showContactSwitch = false)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.multiChatViewerMode.enabled
        ? _c("MultiChatViewer", {
            attrs: { "agent-id": _vm.multiChatViewerMode.value },
            on: {
              close: function () {
                return (_vm.multiChatViewerMode.enabled = false)
              },
              "change-agent-group": _vm.changeAgentGroup,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }